import {
  REQUEST_CAMPAIGN_PAYMENT_LIST
} from './mutation-types'

export default {
  [REQUEST_CAMPAIGN_PAYMENT_LIST](state, receivedData) {
    state.campaignPaymentList = receivedData.content;
    state.campaignPaymentListCount = receivedData.totalElements;
  },
}